import React, { Component } from "react";
import AppModalBs from "../../partials/AppModalBs";

export class NoOfParameterModal extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.NoOfParameterModal = this;
  }

  render() {
    let { id, onClose, parameters = [] } = this.props;

    return (
      <AppModalBs id={id} title="No. Of Parameter" onClose={onClose}>
        <div className="p-3">
          {parameters.map((param, index) => (
            <div key={index} className="mb-3 font-weight-bold d-flex justify-content-between align-items-center" style={{fontSize: "14px", fontWeight: "600"}}>
              <div>
                <span>{param.name}</span>
                {param.category_name && (
                  <span className="ms-2 text-muted" style={{fontSize: "12px", fontWeight: "normal"}}>({param.category_name})</span>
                )}
              </div>
              <span>{param.maxMark !== undefined ? param.maxMark : param.max_marks}</span>
            </div>
          ))}
        </div>
      </AppModalBs>
    );
  }
}

export default NoOfParameterModal;
